import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { getConsent, setConsent } from "../lib/analytics";
import { ArrowLeft } from "@phosphor-icons/react";

const Section = ({ title, children }) => (
  <section className="mt-9">
    <h2 className="font-display text-xl text-[#4A0000]">{title}</h2>
    <div className="mt-2 text-[15px] leading-relaxed text-[#4A4745] space-y-3">{children}</div>
  </section>
);

export default function Privacy() {
  const nav = useNavigate();
  const consent = getConsent();
  const optedOut = consent === "denied";
  const toggle = () => {
    const next = optedOut ? "granted" : "denied";
    setConsent(next);
    toast.success(next === "denied" ? "Analytics & ad cookies turned off." : "Analytics & ad cookies turned on.");
    setTimeout(() => window.location.reload(), 600);
  };
  return (
    <div className="min-h-screen bg-[#FBFAF7] text-[#1A1715]" data-testid="privacy-page">
      <div className="max-w-2xl mx-auto px-6 py-14">
        <button onClick={() => nav(-1)} className="flex items-center gap-1.5 text-sm text-[#8A6A2F] hover:text-[#4A0000] transition-colors" data-testid="privacy-back">
          <ArrowLeft size={16} /> Back
        </button>
        <h1 className="font-display text-4xl text-[#4A0000] mt-6">Privacy &amp; Cookies</h1>
        <p className="mt-3 text-[15px] leading-relaxed text-[#4A4745]">
          This page explains, in plain terms, what we collect when you use Reelty and the choices you have.
        </p>

        <Section title="What we collect">
          <p>When you use the site we collect basic usage data — pages viewed, actions taken (like generating a
          presentation or booking a shoot), approximate location, device/browser, and referral source. If you create
          an account or request a shoot, we also collect the details you provide (name, email, phone, property address).</p>
        </Section>

        <Section title="Analytics & advertising cookies">
          <p>We use <b>Google Analytics 4</b> to measure how the site is used, and the <b>LinkedIn Insight Tag</b> on our
          demo and booking pages to measure ad performance and show relevant ads to people who've visited. These set
          cookies and send usage events to those providers.</p>
        </Section>

        <Section title="Your choices">
          <p>Analytics and ad cookies are on by default; you can turn them off at any time using the button below.
          You can also block cookies in your browser settings or use your browser's
          "Do Not Track" / Global Privacy Control signal.</p>
          <button onClick={toggle} data-testid="privacy-toggle-consent"
            className={`mt-2 px-5 py-2.5 text-sm font-semibold rounded-md transition-colors ${optedOut
              ? "bg-[#B08D57] text-[#1A1715] hover:bg-[#C59B47]"
              : "border border-[#D9CFB0] text-[#4A0000] hover:bg-[#F3EEE2]"}`}>
            {optedOut ? "Turn analytics & ad cookies back on" : "Opt out of analytics & ad cookies"}
          </button>
          <p className="text-[13px] text-[#8A8782]">Current status: {optedOut ? "Opted out" : "Enabled"}.</p>
        </Section>

        <Section title="How we use your data">
          <p>To run and improve the service, fulfil shoots and bookings, communicate with you, and measure our
          marketing. We don't sell your personal information. We share data only with the service providers that help us
          operate (e.g., payments, email, analytics) and as required by law.</p>
        </Section>

        <Section title="Contact">
          <p>Questions about your data or this policy? Email us and we'll help.</p>
        </Section>

        <p className="mt-10 text-[12px] text-[#A8A49E]">Last updated June 2026.</p>
      </div>
    </div>
  );
}
